import Button from '../button'

interface FooterProps {
  count: number
  name: string
  clear: () => void
  onApply: () => void
  isApplyDisabled?: boolean
  errorMessage?: string
}

const DropdownFooter = ({
  count,
  clear,
  onApply,
  name,
  isApplyDisabled,
  errorMessage,
}: FooterProps) => {
  return (
    <div className="px-2 shadow-top">
      <hr className="w-full border-gold-400" />
      {errorMessage && (
        <div className="mb-2 text-right text-red-400">{errorMessage}</div>
      )}
      <div className="flex items-center justify-end gap-2 py-3">
        <Button
          variant="link"
          data-cy={`${name}-selector-clear-all`}
          data-testid={`${name}-selector-clear-all`}
          onClick={clear}
          disabled={!count}
        >
          Clear all {count ? `(${count})` : undefined}
        </Button>

        <Button
          variant="primary"
          size="small"
          data-cy={`${name}-selector-apply`}
          data-testid={`${name}-selector-apply`}
          onClick={onApply}
          disabled={isApplyDisabled}
        >
          Apply
        </Button>
      </div>
    </div>
  )
}

export default DropdownFooter
